export const dataHooks = {
  horizontalTimelineLabel: 'horizontal-timeline-label',
};
